//#region src/registry.ts
var e = null, t = class {
	static register(t) {
		e = t;
	}
	static get() {
		if (!e) throw Error("ErrorReporterRegistry.get() called before register(). Call initSentry() (from @maat/store-sentry) at the app entry point.");
		return e;
	}
	static tryGet() {
		return e;
	}
	static reset() {
		e = null;
	}
};
//#endregion
export { t as ErrorReporterRegistry };
